import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import {
  EatingWay,
  EatingWayDeletePayload,
  EatingWayGetAllPayload,
  EatingWayListResponse,
  EatingWayRestorePayload,
} from './models/EatingWay';

const eatingWayService = {
  getAll(payload: EatingWayGetAllPayload): Promise<CommonResponse<Array<EatingWayListResponse>>> {
    let url = `/eating-ways?display_type=${payload.displayType}`;

    if (payload.name) url += `&name=${payload.name}`;
    if (payload.sale_type_id) url += `&sale_type_id=${payload.sale_type_id}`;
    if (payload.area_type) url += `&area_type=${payload.area_type}`;
    if (payload.except_eating_way_ids) url += `&except_eating_way_ids=${payload.except_eating_way_ids.join(',')}`;
    if (payload.time_frame_id) url += `&time_frame_id=${payload.time_frame_id}`;

    return axiosClient.get(url);
  },
  getItem(id: number): Promise<CommonResponse<EatingWay>> {
    const url = `/eating-way/${id}`;
    return axiosClient.get(url);
  },
  add(payload: Partial<EatingWay>): Promise<CommonResponse<any>> {
    const url = '/eating-ways';
    return axiosClient.post(url, payload);
  },
  update(id: number, payload: Partial<EatingWay>): Promise<CommonResponse<any>> {
    const url = `/eating-way/${id}`;
    return axiosClient.patch(url, payload);
  },
  delete(payload: EatingWayDeletePayload): Promise<CommonResponse<any>> {
    const url = `/eating-ways`;
    return axiosClient.delete(url, { data: payload });
  },
  restore(payload: EatingWayRestorePayload): Promise<CommonResponse<any>> {
    const url = `/eating-ways/restore`;
    return axiosClient.patch(url, payload);
  },
};

export default eatingWayService;
